import classNames from 'classnames';
import * as React from 'react';

import css from './BooksTypeRadio.module.scss';

interface Props {
  className?: string;
  value: string;
  name: string;
  id: string;
  label?: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent) => void;
}

const BooksTypeRadio = ({
  className,
  value,
  name,
  id,
  label,
  checked,
  onChange,
}: Props) => {
  const classes = classNames(css.BooksTypeRadio, className);

  return (
    <span className={classes}>
      <input
        id={id}
        className={css.BooksTypeRadio__Input}
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <label className={css.BooksTypeRadio__Label} htmlFor={id}>
        <span>{label || value}</span>
      </label>
    </span>
  );
};

export default BooksTypeRadio;
